import React from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import EmployeeDocumentUploadForm from './EmployeeDocuments/EmployeeDocumentUploadForm';  
import useEmployeeDocuments from '../../hooks/useEmployeeDocuments';  
import { validateTCNumber } from '../../utils/validators';


const EmployeeCreateModal = ({
    showCreateModal,
    setShowCreateModal,
    formData,
    handleFormChange,
    handleCreateEmployee,
    loading
}) => {
    // Document upload state - 
    const [selectedDocuments, setSelectedDocuments] = React.useState([]);
    const { uploadMultipleDocuments } = useEmployeeDocuments(null);

    // Handle form submit with documents - 
    const handleSubmitWithDocuments = async (e) => {
        e.preventDefault();

        // İlk önce employee oluştur
        const result = await handleCreateEmployee(e);

        // Employee oluşturma başarılıysa ve belgeler varsa yükle
        if (result?.success && selectedDocuments.length > 0) {
            console.log('📁 BELGE UPLOAD BAŞLIYOR...');
            console.log('🆔 Employee ID:', result.data?._id);
            try {
                const employeeId = result.data?._id; // Employee ID'yi al
                console.log('✅ Employee ID alındı:', employeeId);


                if (employeeId) {
                    // Belgeleri upload et
                    const filesWithCategories = selectedDocuments.map(doc => ({
                        file: doc.file,
                        category: doc.category,
                        notes: `${doc.category} belgesi`
                    }));
                    console.log('📤 Upload edilecek belgeler:', filesWithCategories);


                    await uploadMultipleDocuments(employeeId, filesWithCategories);
                    console.log('✅ BELGE UPLOAD TAMAMLANDI!');

                }
            } catch (docError) {
                console.error('Document upload error:', docError);
                // Employee oluştu ama belgeler yüklenemedi - warning göster
            }
        }

        // Modal'ı kapat ve state'i temizle
        if (result?.success) {
            setSelectedDocuments([]);
        }
    };


    return (
        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>👤 Yeni Personel Ekle</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmitWithDocuments}>
                <Modal.Body>
                    {/* Document Upload Form -  */}
                    <EmployeeDocumentUploadForm
                        selectedDocuments={selectedDocuments}
                        setSelectedDocuments={setSelectedDocuments}
                    />
                    <Row>
                        <Col md={6}>
                            <h6>Kişisel Bilgiler</h6>
                            <Form.Group className="mb-3">
                                <Form.Label>Ad Soyad *</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    value={formData.personalInfo.fullName}
                                    onChange={(e) => handleFormChange('personalInfo', 'fullName', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>TC Kimlik No *</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    maxLength="11"
                                    value={formData.personalInfo.tcNo}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ''); // Sadece rakam
                                        handleFormChange('personalInfo', 'tcNo', value);
                                    }}
                                    isInvalid={formData.personalInfo.tcNo && !validateTCNumber(formData.personalInfo.tcNo)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir TC Kimlik numarası giriniz
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Telefon *</Form.Label>
                                <Form.Control
                                    type="tel"
                                    required
                                    value={formData.personalInfo.phone}
                                    onChange={(e) => handleFormChange('personalInfo', 'phone', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Email *</Form.Label>
                                <Form.Control
                                    type="email"
                                    required
                                    value={formData.personalInfo.email}
                                    onChange={(e) => handleFormChange('personalInfo', 'email', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Doğum Tarihi *</Form.Label>
                                <Form.Control
                                    type="date"
                                    required
                                    value={formData.personalInfo.birthDate}
                                    onChange={(e) => handleFormChange('personalInfo', 'birthDate', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Adres *</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    required
                                    value={formData.personalInfo.address}
                                    onChange={(e) => handleFormChange('personalInfo', 'address', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>IBAN Sahibi İsmi</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.personalInfo.ibanHolder}
                                    onChange={(e) => handleFormChange('personalInfo', 'ibanHolder', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>IBAN Numarası</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.personalInfo.ibanNumber}
                                    onChange={(e) => handleFormChange('personalInfo', 'ibanNumber', e.target.value)}
                                    placeholder="TR00 0000 0000 0000 0000 0000 00"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <h6>İş Bilgileri</h6>
                            <Form.Group className="mb-3">
                                <Form.Label>Pozisyon *</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    value={formData.workInfo.position}
                                    onChange={(e) => handleFormChange('workInfo', 'position', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Departman *</Form.Label>
                                <Form.Select
                                    required
                                    value={formData.workInfo.department}
                                    onChange={(e) => handleFormChange('workInfo', 'department', e.target.value)}
                                >
                                    <option value="satış">Satış</option>
                                    <option value="muhasebe">Muhasebe</option>
                                    <option value="insan_kaynakları">İnsan Kaynakları</option>
                                    <option value="bilgi_işlem">Bilgi İşlem</option>
                                    <option value="genel_koordinatör">Genel Koordinatör</option>
                                    <option value="temizlik">Temizlik</option>
                                    <option value="güvenlik">Güvenlik</option>
                                    <option value="diğer">Diğer</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>İşe Başlama Tarihi *</Form.Label>
                                <Form.Control
                                    type="date"
                                    required
                                    value={formData.workInfo.startDate}
                                    onChange={(e) => handleFormChange('workInfo', 'startDate', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Sözleşme Türü *</Form.Label>
                                <Form.Select
                                    required
                                    value={formData.workInfo.contractType}
                                    onChange={(e) => handleFormChange('workInfo', 'contractType', e.target.value)}
                                >
                                    <option value="belirsiz_sureli">Belirsiz Süreli</option>
                                    <option value="belirli_sureli">Belirli Süreli</option>
                                    <option value="deneme_sureli">Deneme Süreli</option>
                                </Form.Select>
                            </Form.Group>
                            {formData.workInfo.contractType !== 'belirsiz_sureli' && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Sözleşme Bitiş Tarihi *</Form.Label>
                                    <Form.Control
                                        type="date"
                                        required
                                        value={formData.workInfo.contractEndDate}
                                        onChange={(e) => handleFormChange('workInfo', 'contractEndDate', e.target.value)}
                                    />
                                </Form.Group>
                            )}
                            <Form.Group className="mb-3">
                                <Form.Label>Maaş *</Form.Label>
                                <Form.Control
                                    type="number"
                                    required
                                    min="0"
                                    step="0.01"
                                    value={formData.workInfo.salary}
                                    onChange={(e) => handleFormChange('workInfo', 'salary', e.target.value)}
                                />
                            </Form.Group>

                            <h6 className="mt-4">Acil Durum İletişim</h6>
                            <Form.Group className="mb-3">
                                <Form.Label>Ad Soyad *</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    value={formData.personalInfo.emergencyContact.name}
                                    onChange={(e) => handleFormChange('emergencyContact', 'name', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Telefon *</Form.Label>
                                <Form.Control
                                    type="tel"
                                    required
                                    value={formData.personalInfo.emergencyContact.phone}
                                    onChange={(e) => handleFormChange('emergencyContact', 'phone', e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Yakınlık Derecesi *</Form.Label>
                                <Form.Select
                                    required
                                    value={formData.personalInfo.emergencyContact.relation}
                                    onChange={(e) => handleFormChange('emergencyContact', 'relation', e.target.value)}
                                >
                                    <option value="eş">Eş</option>
                                    <option value="anne">Anne</option>
                                    <option value="baba">Baba</option>
                                    <option value="kardeş">Kardeş</option>
                                    <option value="çocuk">Çocuk</option>
                                    <option value="arkadaş">Arkadaş</option>
                                    <option value="diğer">Diğer</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
                        İptal
                    </Button>
                    <Button type="submit" variant="primary" disabled={loading}>
                        {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EmployeeCreateModal;